"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformInvoiceRequest = exports.transformInvoiceListResponse = exports.transformInvoiceResponse = void 0;
const Error_1 = require("./Error");
const Money_1 = require("./Money");
const Line_1 = require("./Line");
const InvoiceCustomizedEmail_1 = require("./InvoiceCustomizedEmail");
const Date_1 = require("./Date");
const Owner_1 = require("./Owner");
var AutoBillStatus;
(function (AutoBillStatus) {
    AutoBillStatus["retry"] = "retry";
    AutoBillStatus["failed"] = "failed";
    AutoBillStatus["success"] = "success";
})(AutoBillStatus || (AutoBillStatus = {}));
var DisplayStatus;
(function (DisplayStatus) {
    DisplayStatus["draft"] = "draft";
    DisplayStatus["created"] = "created";
    DisplayStatus["sent"] = "sent";
    DisplayStatus["viewed"] = "viewed";
    DisplayStatus["outstanding"] = "outstanding";
})(DisplayStatus || (DisplayStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["unpaid"] = "unpaid";
    PaymentStatus["partial"] = "partial";
    PaymentStatus["paid"] = "paid";
    PaymentStatus["autoPaid"] = "auto-paid";
})(PaymentStatus || (PaymentStatus = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["disputed"] = "disputed";
    InvoiceStatus["draft"] = "draft";
    InvoiceStatus["sent"] = "sent";
    InvoiceStatus["viewed"] = "viewed";
    InvoiceStatus["paid"] = "paid";
    InvoiceStatus["autoPaid"] = "auto-paid";
    InvoiceStatus["retry"] = "retry";
    InvoiceStatus["failed"] = "failed";
    InvoiceStatus["partial"] = "partial";
})(InvoiceStatus || (InvoiceStatus = {}));
var DepositStatus;
(function (DepositStatus) {
    DepositStatus["paid"] = "paid";
    DepositStatus["unpaid"] = "unpaid";
    DepositStatus["partial"] = "partial";
    DepositStatus["none"] = "none";
    DepositStatus["converted"] = "converted";
})(DepositStatus || (DepositStatus = {}));
var InvoiceV3Status;
(function (InvoiceV3Status) {
    InvoiceV3Status["created"] = "created";
    InvoiceV3Status["draft"] = "draft";
    InvoiceV3Status["sent"] = "sent";
    InvoiceV3Status["viewed"] = "viewed";
    InvoiceV3Status["failed"] = "failed";
    InvoiceV3Status["retry"] = "retry";
    InvoiceV3Status["success"] = "success";
    InvoiceV3Status["autopaid"] = "autopaid";
    InvoiceV3Status["paid"] = "paid";
    InvoiceV3Status["partial"] = "partial";
    InvoiceV3Status["disputed"] = "disputed";
    InvoiceV3Status["resolved"] = "resolved";
    InvoiceV3Status["overdue"] = "overdue";
    InvoiceV3Status["declined"] = "declined";
    InvoiceV3Status["pending"] = "pending";
    InvoiceV3Status["depositPartial"] = "deposit-partial";
    InvoiceV3Status["depositPaid"] = "deposit-paid";
})(InvoiceV3Status || (InvoiceV3Status = {}));
function transformInvoiceResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { invoice } = response.response.result;
    return transformInvoiceParsedResponse(invoice);
}
exports.transformInvoiceResponse = transformInvoiceResponse;
function transformInvoiceListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { invoices, per_page, total, page, pages } = response.response.result;
    return {
        invoices: invoices.map((invoice) => transformInvoiceParsedResponse(invoice)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformInvoiceListResponse = transformInvoiceListResponse;
function transformInvoiceParsedResponse(invoice) {
    return {
        id: invoice.id,
        accountId: invoice.accountid,
        accountingSystemId: invoice.accounting_systemid,
        address: invoice.address,
        amount: invoice.amount && (0, Money_1.transformMoneyParsedResponse)(invoice.amount),
        autoBill: invoice.auto_bill,
        autobillStatus: invoice.autobill_status,
        city: invoice.city,
        code: invoice.code,
        country: invoice.country,
        createDate: invoice.create_date && (0, Date_1.transformDateResponse)(invoice.create_date, Date_1.DateFormat['YYYY-MM-DD']),
        createdAt: invoice.created_at && (0, Date_1.transformDateResponse)(invoice.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        currencyCode: invoice.currency_code,
        currentOrganization: invoice.current_organization,
        customerId: invoice.customerid,
        datePaid: invoice.date_paid,
        depositAmount: invoice.deposit_amount,
        depositPercentage: invoice.deposit_percentage,
        depositStatus: invoice.deposit_status,
        description: invoice.description,
        discountDescription: invoice.discount_description,
        discountTotal: invoice.discount_total && (0, Money_1.transformMoneyParsedResponse)(invoice.discount_total),
        discountValue: invoice.discount_value,
        displayStatus: invoice.display_status,
        disputeStatus: invoice.dispute_status,
        dueDate: invoice.due_date && (0, Date_1.transformDateResponse)(invoice.due_date, Date_1.DateFormat['YYYY-MM-DD']),
        dueOffsetDays: invoice.due_offset_days,
        email: invoice.email,
        estimateId: invoice.estimateid,
        extArchive: invoice.ext_archive,
        fName: invoice.fname,
        fulfillmentDate: invoice.fulfillment_date,
        generationDate: invoice.generation_date,
        gmail: invoice.gmail,
        invoiceNumber: invoice.invoice_number,
        invoiceId: invoice.invoiceid,
        language: invoice.language,
        lastOrderStatus: invoice.last_order_status,
        lines: invoice.lines && invoice.lines.map((line) => (0, Line_1.transformLineParsedResponse)(line)),
        lName: invoice.lname,
        notes: invoice.notes,
        organization: invoice.organization,
        outstanding: invoice.outstanding && (0, Money_1.transformMoneyParsedResponse)(invoice.outstanding),
        owner: invoice.owner && (0, Owner_1.transformOwnerParsedResponse)(invoice.owner),
        ownerId: invoice.ownerid,
        paid: invoice.paid && (0, Money_1.transformMoneyParsedResponse)(invoice.paid),
        parent: invoice.parent,
        paymentDetails: invoice.payment_details,
        paymentStatus: invoice.payment_status,
        poNumber: invoice.po_number,
        province: invoice.province,
        returnUri: invoice.return_uri,
        sentId: invoice.sentid,
        showAttachments: invoice.show_attachments,
        status: invoice.status,
        street: invoice.street,
        street2: invoice.street2,
        template: invoice.template,
        terms: invoice.terms,
        updated: invoice.updated && (0, Date_1.transformDateResponse)(invoice.updated, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        v3Status: invoice.v3_status,
        vatName: invoice.vat_name,
        vatNumber: invoice.vat_number,
        visState: invoice.vis_state,
    };
}
function transformInvoiceRequest(invoice) {
    if (invoice.actionEmail === true) {
        const payload = JSON.stringify({
            invoice: {
                action_email: true,
                email_recipients: invoice.emailRecipients,
                email_include_pdf: invoice.emailIncludePdf,
                invoice_customized_email: invoice.invoiceCustomizedEmail && (0, InvoiceCustomizedEmail_1.transformInvoiceCustomizedEmailRequest)(invoice.invoiceCustomizedEmail),
            },
        });
        return payload;
    }
    if (invoice.actionMarkAsSent === true) {
        return JSON.stringify({
            invoice: {
                action_mark_as_sent: true,
            },
        });
    }
    return JSON.stringify({
        invoice: {
            address: invoice.address,
            auto_bill: invoice.autoBill,
            city: invoice.city,
            code: invoice.code,
            country: invoice.country,
            currency_code: invoice.currencyCode,
            customerid: invoice.customerId,
            create_date: invoice.createDate && (0, Date_1.transformDateRequest)(invoice.createDate),
            deposit_amount: invoice.depositAmount,
            deposit_percentage: invoice.depositPercentage,
            discount_description: invoice.discountDescription,
            discount_value: invoice.discountValue,
            due_offset_days: invoice.dueOffsetDays,
            email: invoice.email,
            estimateid: invoice.estimateId,
            ext_archive: invoice.extArchive,
            fname: invoice.fName,
            fulfillment_date: invoice.fulfillmentDate,
            generation_date: invoice.generationDate,
            invoice_number: invoice.invoiceNumber,
            language: invoice.language,
            last_order_status: invoice.lastOrderStatus,
            lines: invoice.lines && invoice.lines.map((line) => (0, Line_1.transformLineParsedRequest)(line)),
            lname: invoice.lName,
            notes: invoice.notes,
            organization: invoice.organization,
            parent: invoice.parent,
            payment_details: invoice.paymentDetails,
            po_number: invoice.poNumber,
            province: invoice.province,
            return_uri: invoice.returnUri,
            show_attachments: invoice.showAttachments,
            status: invoice.status,
            street: invoice.street,
            street2: invoice.street2,
            template: invoice.template,
            terms: invoice.terms,
            vat_name: invoice.vatName,
            vat_number: invoice.vatNumber,
            vis_state: invoice.visState,
        },
    });
}
exports.transformInvoiceRequest = transformInvoiceRequest;
//# sourceMappingURL=Invoices.js.map